module.exports = __webpack_public_path__ + "img/symbol_4.09bff324.png";